"use client";

import type { StorySlidesBlock } from "@mw/shared/payload-types";

import dynamic from "next/dynamic";

const StorySlides = dynamic(() => import("./BlockStorySlides").then(mod => mod.BlockStorySlides));

export default function BlockStorySlidesWrapper(props: StorySlidesBlock & { inverse?: boolean }) {
  return <StorySlides {...props} />;
}
